<script setup lang="ts">
import { BaseModal, BaseButton } from '@template/ui';

interface Props {
  isOpen: boolean;
}

interface Emits {
  (e: 'close'): void;
  (e: 'confirm'): void;
  (e: 'update:isOpen', value: boolean): void;
}

const props = withDefaults(defineProps<Props>(), {});

const emit = defineEmits<Emits>();
</script>

<template>
  <BaseModal
    :is-open="isOpen"
    :show-default-footer="false"
    :close-on-overlay-click="false"
    showCloseButton
    content-padding="none"
    size="sm"
    title="Open API 이용 안내"
    @close="emit('close')"
    @update:is-open="emit('update:isOpen', $event)"
  >
    <div class="flex flex-col items-center gap-[30px] px-[50px] py-10">
      <!-- 메시지 영역 -->
      <div class="flex flex-col items-center gap-3 text-center">
        <div class="flex flex-col gap-2.5 overflow-y-auto font-medium">
          Open API 서비스는<br />
          실거래 계좌 개설 후 이용할 수 있습니다
        </div>
      </div>

      <!-- 버튼 영역 -->
      <div class="flex w-full items-center justify-center gap-[10px]">
        <BaseButton
          label="취소"
          variant="outlined"
          color="grey"
          size="sm"
          custom-class="w-20 h-10"
          @click="emit('close')"
          full-width
        />
        <BaseButton
          label="계좌 개설하기"
          variant="contained"
          color="primary"
          size="sm"
          custom-class="w-20 h-10"
          @click="emit('confirm')"
          full-width
        />
      </div>
    </div>
  </BaseModal>
</template>
